<template>
  <div>
    <p class="text-dark" v-html="$t('sendActivationLink.activationDescription', {products: this.globalResources.productTranslation.Plural})" />
    <p class="text-dark" v-html="$t('sendActivationLink.spamDescription')" />
  </div>
</template>

<script>
export default {
  name: 'SendActivationCoverText'
}
</script>
